import useApi from "./useApi";

const useCharacter = () => {
  const { get, post, postFile } = useApi();

  const GenerateFromImage = async (image) => {
    try {
      const formData = new FormData();
      formData.append("image", image);

      const response = await postFile("/webapp/generate/3d/", formData);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const GenerateFromPrompt = async (text, order, workflow) => {
    console.log(`GENERATE ${text} ${order}`);
    const data = {
      prompt: text,
      controlnet: order,
      workflow: workflow,
    };
    console.log(data);

    try {
      const response = await post("/webapp/generate/2d/", data);
      return response;
    } catch (error) {
      // console.log(error);
      return error;
    }
  };

  const GenerateModelFromVariant = async (id, index, name) => {
    const data = {
      variant_id: id,
      variant_index: index,
      name,
    };

    try {
      const response = await post("/webapp/generate/3d/", data);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };


  const GenerateFromVRM = async (thumbnail, vrm) => {
    try {
      const formData = new FormData();
      formData.append("thumbnail", thumbnail);
      formData.append("vrm", vrm);

      const response = await postFile("/webapp/generate/vrm/", formData);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };
  
  const GenerateModelFromImage = async (image) => {
    try {
      const formData = new FormData();
      formData.append("image", image);

      const response = await postFile("/webapp/generate/3d/", formData);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };
  
  const GenerateLoraImage = async (prompt, aspect_ratio, loras) => {
    try {
      const data = {
        prompt,
        loras,
        aspect_ratio
      }
      const response = await post("/webapp/generate/image/", data);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  function generateRandomString(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }

  //   const handleGenerate3d = () => {
  //     if ("fromInput" in data) {
  //       if (data.fromInput) {
  //         GenerateNewCharacterFromImageInput(data.image);
  //       }
  //     } else {
  //       GenerateNewCharacterFromVariant(
  //         data.variant_id,
  //         `${data.variant_index}`,
  //         data.name
  //       );
  //     }
  //   };

  return {
    GenerateFromPrompt,
    GenerateFromImage,
    GenerateModelFromVariant,
    GenerateModelFromImage,
    GenerateFromVRM,
    GenerateLoraImage,
  };
};

export default useCharacter;
